import {
  UpdateDividerBundleConfigurationInput,
  UpdateEntityGraphViewBundleConfigurationInput,
  UpdatePresentationCustomPageBundleConfigurationInput,
} from '@/types/schema';

import { BundleSaveDescriptor } from '../presentationSave.types';
import { createFlatConfigDescriptor } from './flatConfigDescriptor';

/**
 * Descriptors for the bundle kinds whose configuration is flat scalars.
 *
 * A cleared string is written as the empty string rather than through the
 * `clearXxx` flag. That is what the form holds — `mapBundleToForm` maps a null
 * column to `''` — and what the create path already sends, so the two paths agree
 * and a value round-trips unchanged.
 */

export const dividerBundleDescriptor: BundleSaveDescriptor =
  createFlatConfigDescriptor({
    field: 'dividerBundleConfiguration',
    read: (bundle) => bundle.dividerBundleConfiguration,
    diff: (previous, next) => {
      const update: UpdateDividerBundleConfigurationInput = {};
      if (previous.dividerTitle !== next.dividerTitle) {
        update.dividerTitle = next.dividerTitle;
      }
      if (previous.customContent !== next.customContent) {
        update.customContent = next.customContent;
      }
      return Object.keys(update).length > 0 ? update : null;
    },
    toPayload: (id, update) => ({
      updateDividerBundleConfiguration: { id, update },
    }),
  });

export const customPageBundleDescriptor: BundleSaveDescriptor =
  createFlatConfigDescriptor({
    field: 'customPageBundleConfiguration',
    read: (bundle) => bundle.customPageBundleConfiguration,
    diff: (previous, next) => {
      const update: UpdatePresentationCustomPageBundleConfigurationInput = {};
      if (previous.pageHeader !== next.pageHeader) {
        update.pageHeader = next.pageHeader;
      }
      if (previous.pageSubheader !== next.pageSubheader) {
        update.pageSubheader = next.pageSubheader;
      }
      if (previous.includePageHeader !== next.includePageHeader) {
        update.includePageHeader = next.includePageHeader;
      }
      return Object.keys(update).length > 0 ? update : null;
    },
    toPayload: (id, update) => ({
      updateCustomPageBundleConfiguration: { id, update },
    }),
  });

export const entityGraphViewBundleDescriptor: BundleSaveDescriptor =
  createFlatConfigDescriptor({
    field: 'entityGraphViewBundleConfiguration',
    read: (bundle) => bundle.entityGraphViewBundleConfiguration,
    diff: (previous, next) => {
      const update: UpdateEntityGraphViewBundleConfigurationInput = {};
      if (previous.displayName !== next.displayName) {
        update.displayName = next.displayName;
      }
      // `entityGraphViewId` is a foreign key, so dropping it has to say so
      // explicitly: an absent field means "leave alone", not "detach".
      if (previous.entityGraphViewId !== next.entityGraphViewId) {
        if (next.entityGraphViewId) {
          update.entityGraphViewID = next.entityGraphViewId;
        } else {
          update.clearEntityGraphView = true;
        }
      }
      return Object.keys(update).length > 0 ? update : null;
    },
    toPayload: (id, update) => ({
      updateEntityGraphViewBundleConfiguration: { id, update },
    }),
  });
